import { GridColDef } from '@mui/x-data-grid-premium';
import { BaseEntity } from 'shared/types/general';
import { useTranslation } from 'react-i18next';
import { DataGridLinkCell } from 'components/cells';
import { createColumns } from 'components/enhanced/data-grid/utils';

export function TypesColumns(): GridColDef[] {
  const { t } = useTranslation();
  return createColumns<BaseEntity>(
    [
      {
        field: 'code',
        renderCell: (params) => (
          <DataGridLinkCell
            params={params}
            basePath="/tenant/types"
            idKey="id"
            passDuplicateState
          />
        )
      },
      {
        field: 'description',
        minWidth: 700,
        editable: true
      }
    ],
    t
  );
}
